import EmblaCarousel from "embla-carousel";
import ClassNames from "embla-carousel-class-names";

export default function (element, data) {
  const emblaApi = EmblaCarousel(
    element.querySelector(".embla__viewport"),
    {
      loop: true,
      align: "center",
      duration: 35,
      //dragFree: true,
    },
    [ClassNames()],
  );

  element
    .querySelector(".embla__prev")
    .addEventListener("click", emblaApi.scrollPrev, false);
  element
    .querySelector(".embla__next")
    .addEventListener("click", emblaApi.scrollNext, false);
}
